'use client';

import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const subscribe = (onChange: () => void) => {
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};

/**
 * Whether the user has asked the OS to minimize non-essential motion. The
 * server snapshot is `false`; purely decorative motion should additionally be
 * gated in CSS via `@media (prefers-reduced-motion: reduce)` so the first
 * paint is correct too.
 */
export const usePrefersReducedMotion = () =>
  useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
